import InquiryBadge from '@activities/customerService/InquiryActivity/components/InquiryLogs/InquiryBadge';
import Column from '@components/Column';
import Text from '@components/Text';
import { InquiryResponse } from '@models/inquiry';

import styles from './styles.module.scss';

interface Props {
    inquiry: InquiryResponse;
}

function InquiryHeader({ inquiry }:Props) {
  const { status, title } = inquiry;
  return (
        <Column fullWidth as='section' spacing={14} className={styles.container}>
            <InquiryBadge status={status}/>
            <Text size='2xl' fontWeight='bold'>
                {title}
            </Text>
        </Column>
  );
}

export default InquiryHeader;
